import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  DesignphotoService,
  ExcelService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "research-Dc-Report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./researchDcReport.html",
})
export class researchDcReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  gridOptions: any;
  rdDept: boolean = false;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  finyearList = [];
  typeList = ["R&D TO WAREHOUSE", "R&D TO TEXTILE", "ALL"];

  filter = {
    groupby: "Ref_no",
    fin_id: "",
    ref_no: "",
    stock_status: "PENDING",
    res_id: "",
    type: "ALL",
  };
  stockStatusList = ["PENDING", "ADDED STOCKS", "ALL"];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "R&D DC Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  exceldata: any;

  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();

  columns = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  user: any;
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private designService: DesignphotoService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    let row = event.row;

    if (this.filter.groupby == "Ref_no") {
      this.filter.groupby = "designColor";
      this.filter.res_id = row.res_id;
    }

    if (this.menu.param == "") {
      this.rdDept = true;
      this.menu.param = row.to_type;
    }

    this.getOrderList();
  }

  onbackbutton() {
    if (this.filter.groupby == "designColor") {
      this.filter.groupby = "Ref_no";
      this.filter.res_id = "";
    }

    if (this.rdDept == true) {
      this.menu.param = "";
      this.rdDept = false;
    }

    this.getOrderList();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;

    this.filterPanel.close();
    this.getOrderList();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getOrderList();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    let params = {
      filter: JSON.stringify(this.filter),
      menu: this.menu.param,
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.designService
      .researchDcReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sampleReport/researchDcReport.ts